/**
 * The default debounce delay time (in ms).
 */
export const defaultDebounceDelay = 600

/**
 * The debounce delay time (in ms) for typeahead multiselect.
 */
export const typeaheadDebounceDelay = 400
